import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import { postImport } from "common/lib/importClient";

const api = new APIClient();

const PSEA_POPULATE = [
  "contractor",
  "contractor.organizationType",
  "agency",
  "coreStandards",
  "coreStandards.supportingDocuments",
  "history",
  "history.agency",
  "history.createdby",
  "createdby",
  "createdby.agency",
  "updatedby",
];

export const getPseaAssessments = (params: any) =>
  api.get(url.GET_PSEA_ASSESSMENTS, params);

export const getPseaAssessment = (id: any, params: any = {}) => {
  if (!params?.populate) params.populate = PSEA_POPULATE;
  return api.get(url.GET_PSEA_ASSESSMENT + "/" + id, params);
};

export const addPseaAssessment = (data: any) =>
  api.createAndUpload(url.ADD_PSEA_ASSESSMENT, data);

export const updatePseaAssessment = (data: any) =>
  api.updateAndUpload(
    url.UPDATE_PSEA_ASSESSMENT + "/" + data.id,
    data.formData
  );

export const deletePseaAssessment = (data: any) =>
  api.delete(url.DELETE_PSEA_ASSESSMENT + "/" + data.id, data);

export const importPseaAssessments = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_PSEA_ASSESSMENTS, data, accessToken, options);

/**
 * Fetches the single PSEA assessment recorded for a contractor, via the main
 * API. Normalised to `{ data: <entity | null> }` so it is interchangeable with
 * the agency variant below.
 */
export const getPseaAssessmentForContractor = async (
  contractorId: any,
  params: any = {}
) => {
  const response: any = await api.get(url.GET_PSEA_ASSESSMENTS, {
    pagination: { page: 1, pageSize: 1 },
    populate: params?.populate || PSEA_POPULATE,
    filters: { contractor: contractorId },
  });
  return { data: response?.data?.[0] || null };
};

// Agency-scoped PSEA Assessments
export const getAgencyPseaAssessments = (params: any) =>
  api.get(url.GET_AGENCY_PSEA_ASSESSMENTS, params);

/**
 * Agency counterpart of `getPseaAssessmentForContractor`. Hits the dedicated
 * by-contractor route, which is covered by the agency `findOne` permission and
 * is not scoped to the caller's own agency.
 */
export const getAgencyPseaAssessmentForContractor = (
  contractorId: any,
  params: any = {}
) =>
  api.get(
    `${url.GET_AGENCY_PSEA_ASSESSMENTS}/by-contractor/${contractorId}`,
    { populate: params?.populate || PSEA_POPULATE }
  );

export const addAgencyPseaAssessment = (data: any) =>
  api.createAndUpload(url.ADD_AGENCY_PSEA_ASSESSMENT, data);

export const updateAgencyPseaAssessment = (data: any) =>
  api.updateAndUpload(
    url.UPDATE_AGENCY_PSEA_ASSESSMENT + "/" + data.id,
    data.formData
  );

// PSEA Ratings (lookup)
export const getPseaRatings = (params: any) =>
  api.get(url.GET_PSEA_RATINGS, params);
